import { searchParametersSlice } from '../redux/slices';

const actions = searchParametersSlice.actions;

/**
 * List of actions that should update the query string depending if a value is applied.
 * If a new action changes filters, and should update the query string we need to add it to this list.
 */
const facetsActionTypes = [
  actions.fetchRvGarages.type,
  actions.fetchAmenities.type,
  actions.fetchCustom.type,
  actions.fetchSingleFamily.type,
  actions.fetchLuxury.type,
  actions.fetchCondosAndTownHomes.type,
  actions.fetchModelHome.type,
  actions.fetchConsumerPromos.type,
  actions.fetchPriceReduction.type,
  actions.fetchBuilderReviews.type,
  actions.fetchActiveAdult.type,
  actions.fetchPrice.type,
  actions.fetchBedrooms.type,
  actions.fetchBathrooms.type,
  actions.clearFilters.type,
  actions.allOptions.type,
  actions.fetchBrandId.type,
  actions.fetchLivingAreas.type,
  actions.fetchStories.type,
  actions.fetchPrimaryBedroom.type,
  actions.fetchGarages.type,
  actions.fetchMoveInDateByRange.type,
  actions.fetchMoveInDateByStatus.type,
  actions.clearMoveInDateFilter.type,
  actions.fetchViewBrandResults.type,
  actions.fetchViewBrandMarketResults.type,
  actions.fetchExcludeActiveAdult.type,
  actions.fetchAnyCommunities.type,
  actions.fetchGolfCourse.type,
  actions.fetchMarketingStatus.type,
  actions.fetchSort.type,
  actions.fetchHomeOwnersAssociationFee.type,
  actions.fetchInteractiveSitePlanResults.type,
];

export default facetsActionTypes;
